import { createContext } from 'react';
import { TaxonomyGroup } from '../reducers/taxonomy';
export const TaxonomyContext = createContext<Map<string, TaxonomyGroup>>(new Map<string, TaxonomyGroup>());
